export interface ColorPalette {
  '100': string;
  '200': string;
  '300': string;
  '400': string;
  '500': string;
  '600': string;
  '700': string;
}

/* ACCENT */
type AccentPalette = Omit<ColorPalette, '200' | '300' | '400' | '500' | '600' | '700'>;
export const AccentPalette: AccentPalette = {
  '100': '#206EF3',
};

/* ACTION */
type ActionPalette = Omit<ColorPalette, '700'>;
export const ActionPalette: ActionPalette = {
  '100': '#FFFFFF',
  '200': '#E9E9EA',
  '300': '#206EF3',
  '400': '#C4C4C5',
  '500': '#7B7B7E',
  '600': '#29293D',
};

/* BRAND */
type BrandPalette = Omit<ColorPalette, '100' | '200' | '300' | '500' | '600'>;
export const BrandPalette: BrandPalette = {
  '400': '#484856',
  '700': '#29293D',
};

/* ERROR */
type ErrorPalette = Omit<ColorPalette, '200' | '300' | '400' | '500' | '600'>;
export const ErrorPalette: ErrorPalette = {
  '100': '#FFD2D2',
  '700': '#BE2F38',
};

/* GRAYSCALE */
type GrayscalePalette = ColorPalette;
export const GrayscalePalette: GrayscalePalette = {
  '100': '#FFFFFF',
  '200': '#F9F9FA',
  '300': '#E9E9EA',
  '400': '#C4C4C5',
  '500': '#7B7B7E',
  '600': '#5A5A5B',
  '700': '#000000',
};

/* SUCCESS */
type NeutralPalette = Omit<ColorPalette, '100' | '200' | '400' | '500' | '700'>;
export const NeutralPalette: NeutralPalette = {
  '300': '#E9E9EA',
  '600': '#5A5A5B',
};

/* PROGRESS */
type ProgressPalette = Omit<ColorPalette, '200' | '300' | '400' | '500' | '600'>;
export const ProgressPalette: ProgressPalette = {
  '100': '#FFFFFF',
  '700': '#206EF3',
};

/* SUCCESS */
type SuccessPalette = Omit<ColorPalette, '200' | '300' | '400' | '500' | '600'>;
export const SuccessPalette: SuccessPalette = {
  '100': '#E0F4F0',
  '700': '#24A878',
};

/* WARNING */
type WarningPalette = Omit<ColorPalette, '200' | '300' | '400' | '500' | '600'>;
export const WarningPalette: WarningPalette = {
  '100': '#FEEBE0',
  '700': '#E76F28',
};
